import { render, staticRenderFns } from "./AddToCartButtonDefault.vue?vue&type=template&id=21be4382&"
import script from "./AddToCartButtonDefault.vue?vue&type=script&lang=js&"
export * from "./AddToCartButtonDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports